import type { DropdownMenuGroup } from '@common/components';

export const SEARCH_CATEGORY_QUERY_KEY = 'category';

export const DEFAULT_SEARCH_CATEGORY = 'all' as const;

export const SEARCH_CATEGORY_GROUPS: DropdownMenuGroup<string>[] = [
  {
    label: '전체',
    options: [{ value: 'all', label: '전체' }],
  },
  {
    label: '웰로',
    options: [
      { value: 'policy', label: '정책' },
      { value: 'hometown-news', label: '동네소식' },
      { value: 'festival', label: '동네축제' },
      { value: 'policy-info', label: '정책 활용 가이드' },
    ],
  },
  {
    label: '고향사랑기부',
    options: [
      { value: 'gifts', label: '답례품' },
      { value: 'hometown-business', label: '지정기부사업' },
    ],
  },
  {
    label: '웰마켙',
    options: [{ value: 'welmarket', label: '웰마켙' }],
  },
];

export const SEARCH_CATEGORY_ITEMS = SEARCH_CATEGORY_GROUPS.flatMap(
  (group) => group.options,
);

export type SearchCategory =
  | 'all'
  | 'policy'
  | 'hometown-news'
  | 'festival'
  | 'policy-info'
  | 'gifts'
  | 'hometown-business'
  | 'welmarket';

export const isSearchCategory = (
  value: string | null | undefined,
): value is SearchCategory =>
  SEARCH_CATEGORY_ITEMS.some((item) => item.value === value);
